import React from "react";
import { Play, ShoppingBag, ChevronDown, Crown } from "lucide-react";
import { ASSETS, ARTIST, STREAMING, STORE_URL, FEATURES } from "../mock";

const Hero = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Full-bleed album cover background */}
      <div className="absolute inset-0">
        <img
          src={ASSETS.albumCover}
          alt="J. Crown - KING"
          className="w-full h-full object-cover object-center scale-105"
        />
        {/* Darken + purple cosmic overlay for readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0410]/70 via-[#1a0b2e]/60 to-[#0a0410]/95" />
        <div className="absolute inset-0 bg-black/30" />
      </div>

      <div className="relative z-10 text-center px-6 pt-24">
        <div className="flex justify-center mb-6">
          <span className="flex items-center justify-center w-16 h-16 rounded-full border border-[#d4af37]/50 bg-black/30 backdrop-blur-sm shadow-[0_0_30px_rgba(212,175,55,0.3)]">
            <Crown className="text-[#e8c65a]" size={30} />
          </span>
        </div>

        <h1 className="heading-display gold-text text-6xl sm:text-7xl md:text-9xl leading-none mb-5 drop-shadow-[0_2px_20px_rgba(0,0,0,0.6)]">
          {ARTIST.name}
        </h1>

        <p className="text-[#e8c65a] tracking-[0.35em] uppercase text-xs sm:text-sm md:text-base mb-10">
          {ARTIST.tagline}
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <button
            onClick={() => scrollTo("#music")}
            className="inline-flex items-center gap-2 px-8 py-4 text-sm tracking-[0.18em] uppercase font-semibold text-[#2a0e47] bg-gradient-to-b from-[#f5d67b] to-[#c8a13c] rounded-sm hover:from-[#ffe38f] hover:to-[#d4af37] transition-all duration-300 shadow-[0_0_30px_rgba(212,175,55,0.35)] hover:-translate-y-0.5"
          >
            <Play size={16} fill="currentColor" /> Listen Now
          </button>
          <button
            onClick={() => scrollTo("#videos")}
            className="inline-flex items-center gap-2 px-8 py-4 text-sm tracking-[0.18em] uppercase font-semibold text-[#e8c65a] border border-[#d4af37]/60 rounded-sm hover:bg-[#d4af37]/10 hover:border-[#d4af37] transition-all duration-300"
          >
            {FEATURES.storeEnabled ? (
              <>
                <ShoppingBag size={16} /> Shop Merch
              </>
            ) : (
              <>
                <Play size={16} /> Watch Videos
              </>
            )}
          </button>
        </div>
      </div>

      <button
        onClick={() => scrollTo("#music")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-[#d4af37]/80 hover:text-[#e8c65a] transition-colors"
      >
        <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
        <ChevronDown size={22} className="animate-bounce" />
      </button>
    </section>
  );
};

export default Hero;
